import React from 'react';
import './FullScreenLoadingSpinner.css';

/**
 * Centered fullscreen loading state (e.g. route transition while fetching).
 */
function FullScreenLoadingSpinner({ label = 'Загрузка…' }) {
  return (
    <div className="promo-fullscreen-loading" aria-busy="true" aria-live="polite">
      <div className="promo-fullscreen-loading-spinner" role="presentation" />
      {label ? <p className="promo-fullscreen-loading-label">{label}</p> : null}
    </div>
  );
}

export default FullScreenLoadingSpinner;
